import React from "react";
import { ChevronDown, MapPin } from "lucide-react";

export default function DriverPortalClientAddress({ clientName, address, quantity }) {
  const [expanded, setExpanded] = React.useState(false);
  const addressId = React.useId();

  return (
    <>
      <div className="driver-command-heading driver-command-heading--disclosure">
        <button type="button" className="driver-client-address-toggle"
          aria-expanded={expanded} aria-controls={address ? addressId : undefined}
          disabled={!address} onClick={() => setExpanded(value => !value)}>
          <MapPin size={14} aria-hidden="true" />
          <span>Client : {clientName || "Non renseigné"}</span>
          {address ? <ChevronDown className="driver-client-address-chevron" size={14} aria-hidden="true" /> : null}
        </button>
        {quantity}
      </div>
      {address ? <p id={addressId} className="driver-command-destination" hidden={!expanded}>{address}</p> : null}
    </>
  );
}
